import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom';

export const OrdersClearSum = ({orders}) => {

    const [isReady, setIsReady] = useState(false);
    useEffect(() => {
        setIsReady(true);
    });

    if (!isReady) {
        return null;
    }

    const clearSum = orders.reduce((total, cur) => cur.clearAmount + total, 0);

    return createPortal(
        <div>
            чистая: <b>{clearSum.toLocaleString('fr-FR')}</b>
        </div>,
        document.getElementById('orders-clear-sum'),
    );
}
